import config from '../../../config'
import store from '../../store'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async habilitar_rol({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(
            `${config.API_URL}/roles/${payload.id}/habilitar`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              }
            }
          )

          const data = await res.json()

          if (data.exito == 1) {
            // borro la variable roles de usuarios para que traiga el rol
            store.commit('usuarios/set_roles', [])
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async inhabilitar_rol({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(
            `${config.API_URL}/roles/${payload.id}/inhabilitar`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              }
            }
          )

          const data = await res.json()

          if (data.exito == 1) {
            // borro la variable roles de usuarios para que no traiga el rol
            store.commit('usuarios/set_roles', [])
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async nuevo_rol({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/roles`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify({ nombre: payload })
          })

          const data = await res.json()

          if (data.exito == 1) {
            // borro la variable roles de usuarios para que traiga el nuevo rol
            store.commit('usuarios/set_roles', [])
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_roles({}, filtro) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(
            `${config.API_URL}/roles/search?nombre=${filtro.nombre}&inhabilitado=${filtro.inhabilitado}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              }
            }
          )

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },

    async getRolesDelUsuario() {
      const response = await fetch(`${config.API_URL}/roles/roles-usuario`, {
        method: 'GET',
        headers: {
          'Content-Type': 'aplication/json',
          Authorization: store.state.token
        }
      })

      return response.json()
    }
  }
}
